import type { Driver } from '@bringg/types';
import type { EtaResponseRouteItem } from '@bringg-frontend/eta-calculator';

import type { RoutesPlannerBreak } from './routes-planner/routes-planner';
import type { RoutesPlannerTask } from '../types';

export type DataChangesNotification = {
	runToTasks: { [runId: number]: RoutesPlannerTask[] };
	runToBreaks: { [runId: number]: RoutesPlannerBreak[] };
	runToDriver: { [runId: number]: Driver };
	routeInfoByIndex: { [runId: number]: EtaResponseRouteItem };
	modifiedTasks: Partial<Bringg.Task>[];
};

export type GanttItemCustomData = {
	noEarlierThan: string;
	noLaterThan: string;
	late: boolean;
	linkedTaskId: number;
};

export enum UpdatingSource {
	Timeline = 'timeline',
	MultipleSelectModal = 'MultipleSelectModal',
	PlannerMap = 'PlannerMap',
	PlannerTable = 'PlannerTable'
}
